(function() {
  'use strict';

  angular.module('app.parcels')
    .controller('ParcelCtrl', ParcelCtrl);

  /** @ngInject */
  function ParcelCtrl($window, sessionService, Parcels, Reports, $uibModal, $templateCache, tracts) { //, esriLoader, esriRegistry, maps
    let vm = this;
    // console.log(vm.fields);
    // let originalData = angular.copy(vm.parcel);
    vm.parcel = vm.parcel[0];
    // console.log('vm.parcel', vm.parcel);

    vm.keydownNumber = 0;
    vm.textAreaLength = 0;

    let initialTotalPrice = vm.parcel.attributes.Total_parcel_price,
        initialLandPrice = vm.parcel.attributes.Land_price,
        initialTimberPrice = vm.parcel.attributes.Timber_price,
        initialImpPrice = vm.parcel.attributes.Imp_price,
        initialSpecPrice = vm.parcel.attributes.Special_price,
        initialComment = vm.parcel.attributes.m_comments;

    // console.log('initialTotalPrice', initialTotalPrice);
    vm.saving = false;

    vm.exporting = false;

    for (let field in vm.fields) {
      if (vm.fields[field].type === 'esriFieldTypeDate') {
        _setupAllDates(vm.fields[field].name);
      }
    }

    vm.getDomainValues = getDomainValues;
    vm.saveParcel = saveParcel;

    //////////


    // vm.addKeyUp = function(e, textModal) {
    //   // console.log(e);
    //   // if (e.target.type === 'textarea') {
    //   //   console.log('textarea');
    //   //   return;
    //   // }
    //   if (typeof(vm.parcel.attributes[textModal]) === 'number') {
    //     // console.log('up', vm.parcel.attributes[textModal]);
    //     if (vm.parcel.attributes[textModal] !== undefined && vm.parcel.attributes[textModal] !== null) {
    //       if (vm.keydownNumber === vm.parcel.attributes[textModal]) {
    //         // console.log('key: ', e.key);
    //         // parsing float and/or ints doesn't appear to work for number fields when the user's entering decimal points
    //         // vm.parattributes[textModal] = vm.parcel.attributes[textModal] * 10;
    //         // if (e.key !== '.') {
    //         //   vm.parcel.attributes[textModal] += parseFloat(e.key);
    //         // }
    //       }
    //     } else {
    //       vm.parcel.attributes[textModal] = parseFloat(e.key);
    //     }
    //   } else if (typeof(vm.parcel.attributes[textModal]) === 'string') {
    //     if (e.which >= 90 || e.which <= 48) {
    //       if (vm.parcel.attributes[textModal] !== undefined && vm.parcel.attributes[textModal] !== null) {
    //         // console.log(e.which, vm.textAreaLength, vm.parcel.attributes[textModal].length);
    //         if (e.which !== 32) {
    //           if (e.which !== 13) {
    //             if (e.which !== 8) {
    //               if (vm.textAreaLength === vm.parcel.attributes[textModal].length) {
    //                 vm.parcel.attributes[textModal] += e.key;
    //               }
    //             }
    //           }
    //         } else {
    //           vm.textAreaLength = vm.parcel.attributes[textModal].length;
    //         }
    //       } else {
    //         vm.parcel.attributes[textModal] = e.key;
    //       }
    //     }
    //
    //   }
    // };

    // vm.addKeyDown = function(e, textModal) {
    //   // console.log(typeof(vm.parcel.attributes[textModal]));
    //   if (typeof(vm.parcel.attributes[textModal]) === 'number') {
    //     if (vm.parcel.attributes[textModal] !== undefined && vm.parcel.attributes[textModal] !== null) {
    //       vm.keydownNumber = vm.parcel.attributes[textModal];
    //     }
    //   } else if (typeof(vm.parcel.attributes[textModal]) === 'string') {
    //     // console.log('down string', vm.parcel.attributes[textModal].length);
    //     if (vm.parcel.attributes[textModal] !== undefined && vm.parcel.attributes[textModal] !== null) {
    //       vm.textAreaLength = vm.parcel.attributes[textModal].length;
    //     }
    //
    //   }
    // };

    // date format
    vm.dateFormat = 'MM/dd/yyyy';

    vm.fOpenStart = function(item) {
      item.open = true;
    };

    vm.fOpenEnd = function() {
      vm.fEndDate.open = true;
    };

    vm.generateAdjacentLetter = function() {
      if (vm.parcel.attributes.ProposedSaleType === 'Direct Sale') {
        let reportFeature = {
          features: []
        };
        let buffer = 5,
          letterType = 'adjacent';
        vm.exportingAdj = true;
        reportFeature.features.push(vm.parcel);
        Reports.formatAdjacentLetterData(reportFeature, buffer, letterType).then(function(results) {
          vm.exportingAdj = false;
          $window.open(results);
        });
      } else {
        alert('This parcel is not marked for Direct Sale');
      }
    };

    vm.generateOwnerLetter = function() {
      let reportFeature = {
        features: []
      };
      vm.exportingOwn = true;
      reportFeature.features.push(vm.parcel);
      Reports.processOwnerNotice(reportFeature).then(function(results) {
        vm.exportingOwn = false;
        $window.open(results);
      });
    };

    function getDomainValues(field) {
      return _.find(vm.fields, {
        'name': field
      }).domain.codedValues;
    }

    function saveParcel() {
      let landPriceDif = 0,
          timberPriceDif = 0,
          impPriceDif = 0,
          specPriceDif = 0,
          priceDif = 0;

      vm.saving = true;

      // set Tract ID and Proposed Sale Type to null if no valid value has been entered
      if (vm.parcel.attributes.Tract === '') {
        vm.parcel.attributes.Tract = null;
      }
      if (vm.parcel.attributes.ProposedSaleType === '') {
        vm.parcel.attributes.ProposedSaleType = null;
      }
      if (vm.parcel.attributes.CityTwpResponse === '') {
        vm.parcel.attributes.CityTwpResponse = null;
      }
      if (vm.parcel.attributes.DNRResponse === '') {
        vm.parcel.attributes.DNRResponse = null;
      }
      // Add up new Total Parcel Price
      vm.parcel.attributes.Total_parcel_price = vm.parcel.attributes.Land_price + vm.parcel.attributes.Imp_price + vm.parcel.attributes.Special_price;

      // Round the total value
      vm.parcel.attributes.Total_parcel_price = Number(vm.parcel.attributes.Total_parcel_price.toFixed(2));

      if (initialLandPrice !== vm.parcel.attributes.Land_price) {
        landPriceDif = vm.parcel.attributes.Land_price - initialLandPrice;
      }
      if (initialTimberPrice !== vm.parcel.attributes.Timber_price) {
        timberPriceDif = vm.parcel.attributes.Timber_price - initialTimberPrice;
      }
      if (initialImpPrice !== vm.parcel.attributes.Imp_price) {
        impPriceDif = vm.parcel.attributes.Imp_price - initialImpPrice;
      }
      if (initialSpecPrice !== vm.parcel.attributes.Special_price) {
        specPriceDif = vm.parcel.attributes.Special_price - initialSpecPrice;
      }

      priceDif = vm.parcel.attributes.Total_parcel_price - initialTotalPrice;
      console.log('---------- Price differences before save tract confirm -----------');
      console.log('Total difference: ', priceDif);
      console.log('Land Price: ', landPriceDif);
      console.log('Timber Price: ', timberPriceDif);
      console.log('Improvement Price', impPriceDif);
      console.log('Special Assessment Price: ', specPriceDif);
      console.log('----------------------------------------');
      if (priceDif !== 0 && vm.parcel.attributes.Tract !== null) {
        priceChangeConfirm(priceDif, vm.parcel.attributes.Last_LS_date, landPriceDif, timberPriceDif, impPriceDif, specPriceDif);
      } else {
        Parcels.update(vm.parcel).then(function() {
          confirmSave();
          for (let field of vm.fields) {
            if (field.type === 'esriFieldTypeDate') {
              _setupAllDates(field.name, vm.parcel.attributes);
            }
          }
          // update the comments field on all parcels that make up a tract if it changed
          if (initialComment !== vm.parcel.attributes.m_comments) {
            Parcels.updateOtherParcelComments(vm.parcel);
            tracts.updateComments(vm.parcel.attributes.Tract, vm.parcel.attributes.m_comments);
            initialComment = vm.parcel.attributes.m_comments;
          }
          // if (vm.parcel.attributes.Tract !== null) {
          //   console.log('priceDif', priceDif);
            // tracts.updateComments(vm.parcel.attributes.Tract, vm.parcel.attributes.m_comments);
          // }
          vm.saving = false;
        });
      }
    }

    function priceChangeConfirm(priceDif, auctionDate, landPriceDif, timberPriceDif, impPriceDif, specPriceDif) {
      let modalInstance = $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/pricechange.tpl.html'),
        controller: 'PriceChangeCtrl',
        size: 'lg',
        resolve: {
          header: function() {
            return 'Price changed for this parcel?';
          },
          data: function() {
            return {
              price: priceDif,
              auctionDate: auctionDate
            };
          }
        }
      });

      modalInstance.result.then(function(auctionDate) {
        // console.log('auctionDate', auctionDate);
        // console.log('YES');
        vm.parcel.attributes.Last_LS_date = auctionDate.date;
        Parcels.update(vm.parcel).then(function() {
          confirmSave();
          for (let field of vm.fields) {
            if (field.type === 'esriFieldTypeDate') {
              _setupAllDates(field.name, vm.parcel.attributes);
            }
          }
          vm.saving = false;
          // update the local variables with correct prices after they've changed
          updateInitialPrices(landPriceDif, timberPriceDif, impPriceDif, specPriceDif);
          // now update the tracts with the new information
          // construct a new tract object for updating
          let updatedTract = {
            attributes: {
              Land_price: landPriceDif,
              Timber_price: timberPriceDif,
              Imp_price: impPriceDif,
              Special_price: specPriceDif,
              Start_bid_price: priceDif
            }
          };
          // update the comments field on all parcels that make up a tract if it changed
          if (initialComment !== vm.parcel.attributes.m_comments) {
            Parcels.updateOtherParcelComments(vm.parcel);
            // tracts.updateComments(vm.parcel.attributes.Tract, vm.parcel.attributes.m_comments);
            updatedTract.attributes.m_comments = vm.parcel.attributes.m_comments;
            tracts.updateTract(vm.parcel.attributes.Tract, updatedTract);
            initialComment = vm.parcel.attributes.m_comments;
          } else {
            tracts.updateTract(vm.parcel.attributes.Tract, updatedTract);
          }
        });
      }, function() {
        // console.log('NO');
        Parcels.update(vm.parcel).then(function() {
          confirmSave();
          for (let field of vm.fields) {
            if (field.type === 'esriFieldTypeDate') {
              _setupAllDates(field.name, vm.parcel.attributes);
            }
          }
          vm.saving = false;
          // update the local variables with correct prices after they've changed
          updateInitialPrices(landPriceDif, timberPriceDif, impPriceDif, specPriceDif);
          // update the comments field on all parcels that make up a tract if it changed
          if (initialComment !== vm.parcel.attributes.m_comments) {
            Parcels.updateOtherParcelComments(vm.parcel);
            tracts.updateComments(vm.parcel.attributes.Tract, vm.parcel.attributes.m_comments);
            initialComment = vm.parcel.attributes.m_comments;
          }
        });
      });
    }

    function confirmSave() {
      $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/alert.tpl.html'),
        controller: 'AlertDialogCtrl',
        size: 'sm',
        resolve: {
          title: function() {
            return 'Parcel Data Saved!';
          },
          message: function() {
            return 'Saved the parcel. Press CLOSE to continue';
          },
          showWarning: function() {
            return true;
          }
        }
      });
    }

    function updateInitialPrices(landPriceDif, timberPriceDif, impPriceDif, specPriceDif) {
      if (landPriceDif !== 0) {
        initialLandPrice = vm.parcel.attributes.Land_price;
      }
      if (timberPriceDif !== 0) {
        initialTimberPrice = vm.parcel.attributes.Timber_price;
      }
      if (impPriceDif !== 0) {
        initialImpPrice = vm.parcel.attributes.Imp_price;
      }
      if (specPriceDif !== 0) {
        initialSpecPrice = vm.parcel.attributes.Special_price;
      }
      // set the initial total price
      initialTotalPrice = vm.parcel.attributes.Total_parcel_price;
    }

    function _setupAllDates(field) {
      if (vm.parcel.attributes[field] !== null) {
        let theDate = new Date(vm.parcel.attributes[field]);
        // console.log(field, vm.parcel.attributes[field]);
        // console.log(theDate);
        vm.parcel.attributes[field] = {
          date: new Date(theDate.getTime() + theDate.getTimezoneOffset() * 60000),
          opened: false
        };
        //  console.log('vm.parcel.attributes[field]', vm.parcel.attributes[field]);
        vm.parcel.attributes[field].date.setDate(vm.parcel.attributes[field].date.getDate());
        //  console.log('date:', vm.parcel.attributes[field].date);
      } else {
        vm.parcel.attributes[field] = {
          date: null,
          opened: false
        };
      }
    }

    // function _formatDate(date) {
    //   return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    // }
  }
})();
